define('store/index',["exports", "redux", "./reducers/index"], function (exports, _redux, _index) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _index2 = _interopRequireDefault(_index);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /*
   * Copyright 2016-2017 ForgeRock AS. All Rights Reserved
   *
   * Use of this code requires a commercial software license with ForgeRock AS.
   * or with one of its affiliates. All use shall be exclusively subject
   * to such license between the licensee and ForgeRock AS.
   */

  var defaultState = {};
  var enhancers = (0, _redux.compose)(window.devToolsExtension ? window.devToolsExtension() : function (f) {
    return f;
  });

  var store = (0, _redux.createStore)(_index2.default, defaultState, enhancers);

  exports.default = store;
});

